import weekOfMonth from "@/utils/weekOfMonth";
import moment from "moment";

const getLabel = (item) => {
    const isCharge = item.amount < 0 ? true : false;
    let label = isCharge ? "Cargo" : "Abono";
    const bci = "BCI (Banco de Crédito e Inversiones) / Banco BCI";
    const bank = item.bank_name === bci ? "BCI" : item.bank_name;
    label = `${label} ${bank}`;
    return { label, isCharge };
};

const chargeColors = ["#FF97AC", "#EE6782", "#F14668", "#9F1468"];
const paymentColors = ["#8EDFE1", "#66CBCE", "#23AAAE", "#019296"];
/**
 * data is suppose to be passed as an array of datasets
 * with properties for label, data and backgroundcolor
 * each dataset represents a bar with his unique color
 */
export default (data, labels, dateInMonths) => {
    let formatedData = [];
    let paymentCounter = 0;
    let chargeCounter = 0;
    data.forEach((value) => {
        const { label, isCharge } = getLabel(value);
        const indexFormatedData = formatedData.findIndex((item) => {
            return item.label === label;
        });

        let indexToInsertValue = undefined;
        if (dateInMonths) {
            const monthText = moment(value.date).format("MMMM");
            indexToInsertValue = labels.findIndex(
                (month) => month.toLowerCase() === monthText.toLowerCase()
            );
        } else {
            indexToInsertValue = weekOfMonth(value.date) - 1;
        }

        const isInFormatedData = indexFormatedData < 0 ? false : true;
        if (isInFormatedData) {
            formatedData[indexFormatedData].data[indexToInsertValue] +=
                value.amount;
        } else {
            let formatedValue = {
                label: label,
                data: new Array(labels.length).fill(0),
                backgroundColor: isCharge
                    ? chargeColors[chargeCounter]
                    : paymentColors[paymentCounter],
            };
            formatedValue.data[indexToInsertValue] += value.amount;
            formatedData.push(formatedValue);
            if (isCharge) {
                chargeCounter += 1;
            } else {
                paymentCounter += 1;
            }
        }
    });
    return formatedData;
};
